import { App as VueApp, createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import axios, { AxiosPromise, AxiosRequestConfig } from "axios";
import qs from "qs";
import { AuthApi } from "@/autogen/api";
import Store from "@/store";
import VueGtm from 'vue-gtm';

import UIkit from "uikit";
import Icons from "uikit/dist/js/uikit-icons";
import "uikit/dist/css/uikit.css";
import "uikit/dist/css/uikit.min.css";
import i18n from "./i18n";
import * as RoleHelper from "./helpers/role-helper";
(UIkit.use as (UIkit: object) => void)(Icons);

axios.interceptors.request.use((config: AxiosRequestConfig) => {
  const url = new URL(config.url || "");
  url.search = qs.stringify(qs.parse(url.search, { ignoreQueryPrefix: true }), {
    arrayFormat: "comma",
    encode: false
  });
  config.url = url.href;
  return config;
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getRefreshToken(err: Error, cb: () => AxiosPromise<any>) {
  const refreshingCall = new AuthApi()
    .authenticate({})
    .then(resp => {
      if (resp.status === 200) {
        Store.getInstance().setAuth(resp.data);
        return Promise.resolve(true);
      } else {
        router.push("/login");
        return Promise.reject(err);
      }
    })
    .then(cb)
    .catch(() => {
      router.push("/login");
      return Promise.reject(err);
    });
  return refreshingCall;
}
axios.defaults.withCredentials = true;
axios.interceptors.response.use(
  response => response,
  err => {
    const orignalRequest = err.config;
    //if access token is expired or user has logout
    if (err.response.status === 401 && !orignalRequest._retry) {
      orignalRequest._retry = true;

      // avoid infinite loop
      if (orignalRequest.url.substr(-13) == "/authenticate") {
        router.push("/login");
        return Promise.reject(err);
      }
      //call refresh token endpoint
      return getRefreshToken(err, () => {
        orignalRequest.headers["Authorization"] = "Bearer " + Store.getInstance().getAccessToken();
        return axios(orignalRequest);
      });
    } else {
      return Promise.reject(err);
    }
  }
);

const rolePlugin = {
  install(app: VueApp) {
    app.config.globalProperties.$role = RoleHelper;
  }
};
createApp(App)
  .use(VueGtm, {id: "GTM-KR9LNCV"})
  .use(i18n)
  .use(router)
  .use(rolePlugin)
  .mount("#app");
